import BtnRemove from './btn-remove';

export default BtnRemove;